import { useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { SiteHeader } from '@/components/layout/site-header'
import { SiteFooter } from '@/components/layout/site-footer'

// Routes that should NOT show header and footer
const ROUTES_WITHOUT_CHROME = [
    '/login',
    '/signup',
    '/verify-otp',
    '/forgot-password',
    '/sso',
    '/questionnaire',
    '/get-started',
    '/redeem',
    '/dashboard',
    '/admin',
    '/learning-dashboard',
]

export function shouldShowChrome(pathname: string): boolean {
    return !ROUTES_WITHOUT_CHROME.some(route => pathname.startsWith(route))
}

export function ConditionalLayout({ children }: { children: ReactNode }) {
    const { pathname } = useLocation()
    const showChrome = shouldShowChrome(pathname)

    if (!showChrome) {
        return <>{children}</>
    }

    return (
        <div className="min-h-screen bg-[#F6F7F7] text-slate-900">
            <SiteHeader />
            <main className="mx-auto">{children}</main>
            <SiteFooter />
        </div>
    )
}
